<template>
  <div class="row">
    <div class="col-12 col-md-6">
      <router-link tag="a" :to="{name: 'PhraseDiary'}" class="content-card-tasks card-phrase--diary">
        <div class="content-card-tasks--text">
          <img class="img-fluid" src="@/assets/img/mensage.png" alt="icon mensage" title="icon mensage"/>
          <p>Frase do dia</p>
        </div>
        <div class="content-card-tasks--check">
          <img class="img-fluid" v-if="Object.keys(phraseDiary).length > 0" src="@/assets/img/checked.png" alt="icon checked" title="icon checked"/>
          <img class="img-fluid" v-else src="@/assets/img/check-mark.png" alt="icon check mark" title="icon check mark"/>
        </div>
      </router-link>
    </div>
    <div class="col-12 col-md-6">
      <router-link tag="a" :to="{name: 'Text'}" class="content-card-tasks card--text" href="/message/">
        <div class="content-card-tasks--text">
          <img class="img-fluid" src="@/assets/img/note.png" alt="icon note" title="icon note"/>
          <p>Texto</p>
        </div>
        <div class="content-card-tasks--check">
          <img class="img-fluid" v-if="Object.keys(text).length > 0" src="@/assets/img/checked.png" alt="icon checked" title="icon checked"/>
          <img class="img-fluid" v-else src="@/assets/img/check-mark.png" alt="icon check mark" title="icon check mark"/>
        </div>
      </router-link>
    </div>
    <div class="col-12 col-md-6">
      <router-link tag="a" :to="{name: 'Challenges'}" class="content-card-tasks card--challenges" href="/challenges/">
        <div class="content-card-tasks--text">
          <img class="img-fluid" src="@/assets/img/fogueira.png" alt="icon fogueira" title="icon fogueira"/>
          <p>Desafios</p>
        </div>
        <div class="content-card-tasks--check">
          <img class="img-fluid" v-if="Object.keys(challenges).length > 0" src="@/assets/img/checked.png" alt="icon checked" title="icon checked"/>
          <img class="img-fluid" v-else src="@/assets/img/check-mark.png" alt="icon check mark" title="icon check mark"/>
        </div>
      </router-link>
    </div>
    <!-- <div class="col-12 col-md-6">
      <router-link tag="a" :to="{name: 'Bonus'}" class="content-card-tasks card--bonus" href="/bonus/">
        <div class="content-card-tasks--text">
          <img class="img-fluid" src="@/assets/img/bonus.png" alt="icon bonus" title="icon bonus"/>
          <p>Bônus</p>
        </div>
        <div class="content-card-tasks--check">
          <img class="img-fluid" src="@/assets/img/check-mark.png" alt="icon check mark" title="icon check mark"/>
          <template v-if="checked">
            <img class="img-fluid" src="@/assets/img/checked.png" alt="icon checked" title="icon checked"/>
          </template>
        </div>
      </router-link>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      checked: false,
    }
  },
  computed: {
    ...mapGetters('Tasks', ['currentTask', 'phraseDiary', 'text', 'challenges'])
  },
  methods: {
    ...mapActions('Tasks', ['consultPhraseDiary', 'consultText', 'consultChallengesByIdTask']),
    async consultTasks() {
      let id_task = await this.currentTask.id;
      this.consultPhraseDiary(id_task);
      this.consultText(id_task);
      this.consultChallengesByIdTask(id_task);
    }
  },
  async mounted() {
    await this.consultTasks();
  }
}
</script>

<style lang="scss" scoped>
  .content-card-tasks {
    height: 70px;
    background: var(--white);
    box-shadow: 0px 1px 3px rgba(0,0,0,0.25);
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px 0px 15px;
    margin-bottom: 30px;
    transition: 500ms;
    &:hover,&:focus {
      cursor: pointer;
      opacity: 0.6;
    }
    &--text {
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        font-size: 20px;
        font-family: 'Font Semibold';
        margin-left: 15px;
        margin-bottom: 0;
      }
    }
    &--check {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .card-phrase--diary {
    color: var(--pink);
  }
  .card--text {
    color: var(--blue);
  }
  .card--challenges {
    color: var(--red);
  }
  .card--bonus {
    color: var(--orange);
  }
</style>
